<template>
  <div class="executor-fees-summary">
    <h4>Executor fees:</h4>
    <p>
      Executorship<span>{{ executorship }}</span>
    </p>
    <p>
      Default Executor's fee:<span
        >{{ testator.company.defaultExecutorFeePercentage }}%</span
      >
    </p>
    <p>
      Negotiates Executor's fees?<span>{{ negotiatesExecutorsFees }}</span>
    </p>

    <div v-if="showExecutorFeeForTestator">
      <p v-if="!editNegotiableExecutorFee">
        Executor's fee for this testator:
        <span>{{ executorFeeForThisTestator }}</span>
        <v-icon
          color="dark-grey"
          @click.stop="editNegotiableExecutorFee = true"
          >{{ icons.mdiPencilOutline }}</v-icon
        >
        <v-icon
          color="dark-grey"
          class="ml-2"
          @click.stop="clearNegotiableExecutorFee"
          >{{ icons.mdiTrashCanOutline }}</v-icon
        >
      </p>

      <ValidationObserver v-else ref="observer">
        <v-form @submit.prevent="submit">
          <ValidationProvider
            id="negotiated_executor_fee"
            v-slot="{ errors }"
            name="negotiated_executor_fee"
            rules="required|min_value:0.5|max_value:3.5"
          >
            <v-text-field
              v-model="negotiatedExecutorFeePercentage"
              class="edit-neg-executor-fee-field"
              label="Executor's fee for this testator"
              placeholder="e.g. 2.5"
              suffix="%"
              :error-messages="errors"
            />
          </ValidationProvider>

          <v-btn
            :loading="buttonLoading"
            rounded
            depressed
            type="submit"
            color="primary"
          >
            Save
          </v-btn>

          <v-btn
            :loading="buttonLoading"
            rounded
            depressed
            color="grey"
            @click="cancelEditExecutorFee"
          >
            Cancel
          </v-btn>
        </v-form>
      </ValidationObserver>
    </div>

    <ErrorSnackbar v-model="showError" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../../mixins/form-helper-mixin';
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';
  import { SET_NEGOTIATED_EXECUTOR_FEE_MUTATION } from '../../../constants/graphql/testators';

  export default {
    name: 'ExecutorFees',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        negotiatedExecutorFeePercentage: JSON.parse(
          JSON.stringify(this.testator.negotiatedExecutorFeePercentage)
        ),
        editNegotiableExecutorFee: false,
        showSuccess: false,
        successMessage: null,
      };
    },
    computed: {
      negotiatesExecutorsFees() {
        return this.testator.company.negotiableExecutorFee ? 'Yes' : 'No';
      },
      showExecutorFeeForTestator() {
        return this.testator.company.negotiableExecutorFee;
      },
      executorFeeForThisTestator() {
        return this.testator.negotiatedExecutorFeePercentage
          ? this.testator.negotiatedExecutorFeePercentage + '%'
          : 'Not set - uses default fee (' +
              this.testator.company.defaultExecutorFeePercentage +
              '%)';
      },
      executorship() {
        switch (this.testator.company.executorship) {
          case 'COMPANY_ONLY':
            return 'Only our company';
          case 'COMPANY_OR_PERSON':
            return 'Our company or user selected nomination';
          case 'INTERNAL_COMPANY_OR_PERSON':
            return `${this.whitelabel.name} or user selected nomination`;
          case 'INTERNAL_COMPANY_ONLY':
            return `${this.whitelabel.name} only`;
          default:
            return '';
        }
      },
    },
    methods: {
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.saveNegotiableExecutorFee();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      saveNegotiableExecutorFee() {
        const testatorId = this.testator.id;
        const negotiatedExecutorFeePercentage = parseFloat(
          this.negotiatedExecutorFeePercentage
        );

        this.$apollo
          .mutate({
            mutation: SET_NEGOTIATED_EXECUTOR_FEE_MUTATION,
            variables: {
              testatorId,
              negotiatedExecutorFeePercentage,
            },
          })
          .then(data => {
            this.buttonLoading = false;
            this.successMessage = 'Testator updated sucessfully';
            this.showSuccess = true;
            this.editNegotiableExecutorFee = false;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      clearNegotiableExecutorFee() {
        this.negotiatedExecutorFeePercentage = null;
        this.saveNegotiableExecutorFee();
      },
      cancelEditExecutorFee() {
        this.negotiatedExecutorFeePercentage = JSON.parse(
          JSON.stringify(this.testator.negotiatedExecutorFeePercentage)
        );
        this.editNegotiableExecutorFee = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .executor-fees-summary {
    p {
      span {
        font-weight: bold;
        margin: 0 10px;
      }
    }

    .edit-neg-executor-fee-field {
      max-width: 250px;
    }
  }
</style>
